module.exports = __webpack_public_path__ + "img/my_open_redpack_bg_2.d3af2573.png";